import { render, staticRenderFns } from "./ValidateModal.vue?vue&type=template&id=a0f524b4&scoped=true"
import script from "./ValidateModal.vue?vue&type=script&lang=js"
export * from "./ValidateModal.vue?vue&type=script&lang=js"
import style0 from "./ValidateModal.vue?vue&type=style&index=0&id=a0f524b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f524b4",
  null
  
)

export default component.exports